// alle Änderugnen die hier gemacht werden und auch den Header in Zendesk betreffen MÜSSEN!!!! auch in public/zendesk/header.js händisch hinzugefügt werden


$(document).ready(function () {

  var $body = $('body');
  
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'class') {
        var attributeValue = $(mutation.target).prop(mutation.attributeName);
        if(attributeValue.indexOf('compensate-for-scrollbar') != -1) {
          $temp = parseInt($('body').css('marginRight').replace('px', ''));
          if(window.innerWidth < 1200){
            $('body .header-container .wrapper').css('padding-right',$temp+'px');
          } else {
            $('body .header-container').css('left','-'+$temp/2+'px');
          }
        } else {
          if(window.innerWidth < 1200){
            $('body .header-container .wrapper').css('padding-right','0px');
          } else {
            $('body .header-container').css('left','0px');
          }
        }
      }
    });
  });
  
  observer.observe($body[0], {
    attributes: true
  });

  
  $('.pt_hamburger').on('click', function(e){
    e.preventDefault();
    
    if($('header nav').hasClass('navOpen')) {
      $('html').css('overflow', 'auto');
      $('.header-container').removeClass('burgerOpen');
      $('header nav').stop().hide(300).removeClass('navOpen');
      if($(window).scrollTop() == 0 && !$('header nav').hasClass('navOpen')) {
        $('.header-container').removeClass('scrolled');
      }
    } else {
      $('html').css('overflow', 'hidden');
      $('header nav').stop().show(300).addClass('navOpen');  
      $('.header-container').addClass('burgerOpen');
      addMenuShadow();
    }
    
  });
  
  $('header a.logo').on('click', function(){
    
    if($('header nav').hasClass('navOpen')) {
      $('header nav').stop().hide(300).removeClass('navOpen');
      if($(window).scrollTop() == 0 && !$('header nav').hasClass('navOpen')) {
        $('.header-container').removeClass('scrolled');
      }
    } 
    
  }); 
  
  $('header .metaMenus .lang .current a').on('click', function(e){
    e.preventDefault();
    return false;
  }); 
  
  
  var sections = new Array();
  
  var lastVisible = '';
  
  addCurrentToBlogLink();
  /*servicespage
  supportpage
jobspage  */
  $(window).on('scroll', function() {
    addMenuShadow();

    if($(window).scrollTop() == 0 && !$('header nav').hasClass('navOpen')) {
      $('.header-container').removeClass('scrolled');
    }
    
    if($('body').hasClass('landingpage') || $('body').hasClass('success-story-detail-page') || $('body').hasClass('successstory') || $('body').hasClass('blog') || $('body').hasClass('territory-optimization-comparison-bc') || $('body').hasClass('single') || $('body').hasClass('category') || $('body').hasClass('search') || $('body').hasClass('api-page')) { //START scroll for landingpage
     
      var lastPercentage = 0;
      
      $('section .navtarget').each(function(){
        
        var section = $(this).closest('section');
        
        var el = section[0];
        var rect = el.getBoundingClientRect();

        var windowHeight = (window.innerHeight || document.documentElement.clientHeight);
        var windowWidth = (window.innerWidth || document.documentElement.clientWidth);

        var vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);

        if(vertInView) {
            var visibleHeight = 0;
            
            if(rect.top > 0){
              visibleHeight = windowHeight - rect.top;
            } else {
              visibleHeight = rect.height + rect.top;
            }
            
            var percentageOfScreen = visibleHeight*100/windowHeight;
            
            
            if(visibleHeight > windowHeight) {
              lastVisible = $(this).attr('id');
              lastPercentage = 100;
            } 
            else if (visibleHeight > rect.height){
              lastVisible = $(this).attr('id');
              lastPercentage = 100;
            } 
            else if(percentageOfScreen > 50) {
              
              if(percentageOfScreen > lastPercentage) {
                lastVisible = $(this).attr('id');
                lastPercentage = percentageOfScreen;
              }
              
            }
            
            if(lastPercentage == 0) lastVisible = '';
        }
        
      });
      
      $("nav li, .storyNav li a, .to-comp-menu li a").removeClass('current');
      $(".storyNav li").removeClass('current');
      
      if(lastVisible != '') {
        $("nav li a[href$='"+'#'+lastVisible+"']").parent().addClass('current');
        
        $("nav li a[href$='"+'#'+lastVisible+"']").parent().closest('.hasSubmenue').addClass('current');
        
        $(".storyNav li a[href$='"+'#'+lastVisible+"']").addClass('current');
        
        $(".storyNav li a[href$='"+'#'+lastVisible+"']").parent().addClass('current');
        
        $(".to-comp-menu li a[href$='"+'#'+lastVisible+"']").addClass('current');
        
      }
      
      addCurrentToBlogLink();
      
    } //END scroll for landingpage
        
  });
  
  $isMobileMenu = false;
  
  $(window).on('resize', function() {
    
    var windowWidth = window.innerWidth;
    
    if(windowWidth <= 991 && !$isMobileMenu) {
      $isMobileMenu = true;
    }
    
    if(windowWidth > 991 && $isMobileMenu) { 
      $isMobileMenu = false;
      $('header nav').attr('style','').removeClass('navOpen');
    }
    
    $('.first-container').css('margin-top', $('.header-container').height());
    
  });
  
  $(window).trigger('resize');
  
  $('.header-container nav li.hasSubmenue > a').on('click', function(e){
    e.preventDefault();
    
    if($(this).parent().hasClass('open')) {
      $(this).parent().removeClass('open');
    } else {
      $(this).parent().parent().find('.open').removeClass('open'); /* TODO: this line should not be rendered for zendesks header.js */
      $(this).parent().addClass('open');
    }
    
  });
    
  $('body').on('click', '.header-container nav li a', function(e){
    $href=$(this).attr('href');
    if($href[0] == '#') {
      
      if(typeof window.animateScroll == 'undefined') e.preventDefault();
      else if (window.animateScroll) e.preventDefault();
      
      if($href.length > 1){
        $('html, body').stop().animate({ scrollTop: $($href).offset().top }, 750, function(){
          window.location.hash = $href;
        });
        $('.header-container nav li').removeClass('current');
        $(this).parent().addClass('current');
      } 
      if($isMobileMenu && !$(this).parent().hasClass('hasSubmenue')) {
        $('.pt_hamburger').click();
      }
      
    } else {
      if($href[0] == '#' && !$(this).parent().hasClass('hasSubmenue')) {
        if($('header nav').hasClass('navOpen')) {
          $('header nav').stop().hide(300).removeClass('navOpen');
          if($(window).scrollTop() == 0 && !$('header nav').hasClass('navOpen')) {
            $('.header-container').removeClass('scrolled');
          }
        }
      }
    }
  });
  
  function addMenuShadow() {
    if(!$('.header-container').hasClass('scrolled')) {
      $('.header-container').addClass('scrolled');
    }
  }
  
  function addCurrentToBlogLink() {
    if($('body').hasClass('blog') || $('body').hasClass('single') || $('body').hasClass('category') || $('body').hasClass('search') ){
      $("nav li a[href^='/blog']").parent().addClass('current').closest('.hasSubmenue').addClass('current');
    }
  }

});